import React, {useEffect, useState} from "react";
import OneWaySlider from "../../../Componnets/OneWaySlider/OneWaySlider";
import styles from "./processExplorer/ProcessExplorer.module.scss";

const ProcessExplorer = props => {
  const [currentActivityCount, setCurrentActivityCount] = useState(0);
  const [currentEdgeCount, setCurrentEdgeCount] = useState(0);

  useEffect(() => {
    setCurrentEdgeCount(props.currentEdgeCount)
  }, [props.currentEdgeCount])

  useEffect(() => {
    setCurrentActivityCount(props.currentActivityCount)
  }, [props.currentActivityCount])

  const handleActivities = (value) => {
    setCurrentActivityCount(value);
  }

  const handleEdges = (value) => {
    setCurrentEdgeCount(value);
  }

  const handleCallActivitiesFunction = () => {
    props.handleActivity(currentActivityCount)
  }

  const handleCallEdgesFunction = () => {
    props.handleEdge(currentEdgeCount)
  }

  return (
    <div className={styles.ProcessExplorer}>
      <OneWaySlider
        title={"Activities"}
        type={"activities"}
        min={props.minActivityCount}
        max={props.maxActivityCount}
        activeNode={currentActivityCount}
        currentValue={props.currentActivityCount}
        setActive={(value) => handleActivities(value)}
        callFunction={() => handleCallActivitiesFunction()}
        percentage={Math.round(props.activityCoverage * 100)}
      />
      <OneWaySlider
        title={"Edges"}
        type={"edges"}
        min={props.minEdgeCount}
        max={props.maxEdgeCount}
        activeNode={currentEdgeCount}
        currentValue={props.currentEdgeCount}
        setActive={(value) => handleEdges(value)}
        callFunction={() => handleCallEdgesFunction()}
        percentage={Math.round(props.edgeCoveragePerActivity * 100)}
        onEdgesTouched={props.onEdgesTouched}
        isEdgesTouched={props.isEdgesTouched}
      />
      <div className={styles.info}>
        <div className={styles.title}>
          <h4>Coverage</h4>
          <span>on the full<br/>data frame</span>
        </div>
        <div className={styles.percentages}>
          <div className={styles.content}>
            <h4>Edges</h4>
            <span>{Math.round(props.edgeCoveragePerEventLog * 100)}%</span>
          </div>
          <div className={styles.content}>
            <h4>Activities</h4>
            <span>{Math.round(props.activityCoverage * 100)}%</span>
          </div>
        </div>
      </div>
    </div>
  )
};

export default ProcessExplorer;
